import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { Provider } from "react-redux";
import store from "./shared/redux/store/index.ts";
import { AuthProvider } from "@lift-admin/utils/provider";
import { PostHogProvider } from "posthog-js/react";
import { FlagProvider } from "@unleash/proxy-client-react";
import theme from "../packages/ui/src/theme.ts";
import { CssBaseline, ThemeProvider } from "@mui/material";
import ThemeVariables from "../packages/ui/src/themeVariables.tsx";
import { QueryProvider } from "./features/request-list/provider/query-provider.tsx";
import "./styles/globals.css";

const options = {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
};

const unleashConfig = {
  url: import.meta.env.VITE_UNLEASH_CLIENT_URL,
  clientKey: import.meta.env.VITE_UNLEASH_API_TOKEN,
  refreshInterval: 15,
  appName: "Lift-App",
};

// Only enable Unleash if URL and token are provided
const isUnleashEnabled =
  import.meta.env.VITE_UNLEASH_CLIENT_URL &&
  import.meta.env.VITE_UNLEASH_API_TOKEN;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_POSTHOG_KEY}
      options={options}
    >
      <QueryProvider>
        <Provider store={store}>
          <AuthProvider>
            {isUnleashEnabled ? (
              // Note: CORS errors from Unleash server are expected if the server doesn't allow
              // requests from this origin. The app will continue to work without feature flags.
              <FlagProvider config={unleashConfig}>
                <ThemeProvider theme={theme}>
                  {/* <CssBaseline /> */}
                  <ThemeVariables />
                  <App />
                </ThemeProvider>
              </FlagProvider>
            ) : (
              <ThemeProvider theme={theme}>
                {/* <CssBaseline /> */}
                <ThemeVariables />
                <App />
              </ThemeProvider>
            )}
          </AuthProvider>
        </Provider>
      </QueryProvider>
    </PostHogProvider>
  </React.StrictMode>
);
